import ActivationInputForm from './ActivationInputForm';

export default ActivationInputForm;
